// extracted by mini-css-extract-plugin
export default {"homePageBlock":"HomePageblock_homePageBlock__5SATA","homePageBlockImage":"HomePageblock_homePageBlockImage__1ctGf","homePageBlockText":"HomePageblock_homePageBlockText__MKG3w"};